import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import AddBoxIcon from '@mui/icons-material/AddBoxRounded';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import endpoints, { apiRequest } from '../../endpoints';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import FeedsTable from './tables/FeedsTable'
import Loading from '../pages/parts/Loading'
import Error from './parts/Error';
import EditFeedModal from './modals/EditFeedModal'
import withAlert from '../../hoc/withAlerts'
import { setHeader } from '../../redux/headerSlice'
import Confirmation from './modals/Confirmation';
import Warning from './modals/Warning';
import Grow from '@mui/material/Grow';

function Feeds(props) {
    const [list, setList] = useState(null)
    const [loading, setLoading] = useState(false);
    const [dialogData, setDialogData] = useState(null)
    const [dialogType, setDialogType] = useState(null)
    const [deleteItem, setDeleteItem] = useState()
    const [statusItem, setStatusItem] = useState()
    const [warningText, setWarningText] = useState()
    const dispatch = useDispatch()
    
    const feedsUpdateHandler = () => {
        getList()
    }

    useEffect(() => {
        getList();
        dispatch(setHeader({
            title: 'Feeds'
        }))
        
        window.addEventListener('FEEDS_UPDATED', feedsUpdateHandler)
        window.addEventListener('LOAD_RSS_COMPLETED', feedsUpdateHandler)        
        window.addEventListener('ESTIMATOR_COMPLETED', feedsUpdateHandler)
        return () => {
            window.removeEventListener('FEEDS_UPDATED', feedsUpdateHandler) 
            window.removeEventListener('LOAD_RSS_COMPLETED', feedsUpdateHandler)
            window.removeEventListener('ESTIMATOR_COMPLETED', feedsUpdateHandler)
        }
    }, []);

    const token = useSelector((state) => state.auth.token)

    const getList = async () => {
        setLoading(true)
        try {
            const res = await apiRequest('get', endpoints.feeds_ext, {
                token: token,
                columns: 'processed',
            })
            setList(res.data.items)
        } catch (e) {
            setList([])
            showAlertError('Unknown Error - get list')
        }
        setLoading(false)
    }
    
    const saveHandle = (data) => {
        setDialogData(null)
        getList()
        
        // Dispatch for update
        window.dispatchEvent(new Event('FEEDS_UPDATED'));
    }
    
    const cloneHandle = (data) => {
        let copy = Object.assign({}, data)
        copy.id = null
        copy.name += ' (COPY)'
        copy.cloning = true
        
        let context = data.finder.context
        let filter =  data.finder.filter
        let instructions = []
        
        let i = -1;
        data.finder.instructions.forEach(function (item) {
            instructions.push({
                id: i--,
                context: item.context,
                result_invert: item.result_invert,
                type: item.type,
            })
        })
        
        copy.finder = {
            context: context,
            filter: filter,
            instructions: instructions,
        }
        
        console.log(copy)
        
        setDialogData(copy)
    }
    
    const confirmStatusHandle = async (response) => {
        if (response) {
            try {
                const res = await apiRequest('put', endpoints.feeds_ext_status, {
                    token: token,
                    id: statusItem.id,
                    status: statusItem.status != 'active' ? 'active' : 'inactive',
                })
                await getList()
            } catch (e) {
                //
            }
        }
        setStatusItem(null)
    }
    
    const confirmDeleteHandle = async (response) => {
        if (response) {
            try {
                const res = await apiRequest('delete', endpoints.feeds_ext_delete, {
                    token: token,
                    id: deleteItem.id,
                })
                await getList()
                showAlertSuccess('Item deleted successfully!')
                
                // Dispatch for update
                window.dispatchEvent(new Event('FEEDS_UPDATED'));
            } catch (e) {
                showAlertError('Unknown Error - delete Item')
            }
        }
        setDeleteItem(null)
    }

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Grow in={list ? true : false}>
            <Stack sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '8px' }}>
                <Stack spacing={2} direction="row" sx={{pb: 2}} justifyContent="space-between">
                    <Stack sx={{ flexGrow: 1 }}/>
                    <FormControl variant="standard" sx={{ paddingTop:1.5 }}>
                        <Button variant="contained" startIcon={<AddBoxIcon />} onClick={() => {setDialogData({status: 'inactive'})}}>
                            Add Feed
                        </Button>
                    </FormControl>
                </Stack>
                <Stack>
                    <FeedsTable
                        items={list}
                        btnEditHandle={(item) => {setDialogData(item)}}
                        btnCloneHandle={(item) => {cloneHandle(item)}}
                        btnDeleteHandle={(item) => {setDeleteItem(item)}}
                        btnChangeStatus={(item) => {setStatusItem(item)}}
                    />
                </Stack>
                <Confirmation 
                    data={statusItem} 
                    onResponse={confirmStatusHandle}
                    labelNo="Cancel"
                    labelYes={statusItem?.status == 'active' ? 'Turn off' : 'Turn on'}
                />
                <Confirmation 
                    data={deleteItem} 
                    onResponse={confirmDeleteHandle} 
                    content={'Delete the "' + deleteItem?.name + '" feed and all data associated with it?'} 
                />
                <EditFeedModal 
                    dialogData={dialogData}
                    dialogType={dialogType}
                    onClose={() => {setDialogData(null)} }
                    onSave={saveHandle}
                >
                </EditFeedModal>
                <Warning text={warningText} onClose={() => {setWarningText(null)}} />
            </Stack>
        </Grow>
    );
}

export default withAlert(Feeds)